import { render, staticRenderFns } from "./ConnectGameAccountSmallButton.vue?vue&type=template&id=c4d28e56&scoped=true&"
import script from "./ConnectGameAccountSmallButton.vue?vue&type=script&lang=ts&"
export * from "./ConnectGameAccountSmallButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d28e56",
  null
  
)

export default component.exports